import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import moment from 'moment';


export const xTokenInterceptorFn: HttpInterceptorFn = (req, next) => {

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse) {
        const newToken = event.headers.get('x-token');
        if (newToken) {
          localStorage.setItem('_accessToken', JSON.stringify(newToken));
        }
      }
    })
  );
}
